import appLayout from '../layouts/AppLayout.vue'
import DefaultLayout from '../layouts/DefaultLayout.vue'
export default [
  {
    path: '/booking',
    name: 'booking-list',
    component: () => import('../views/booking/BookingIndex.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/booking/external/:id-:key',
    name: 'booking-external',
    component: () => import('../views/booking/BookingAccept.vue'),
    meta: { layout: DefaultLayout }
  },
  {
    path: '/booking/:id/voucher',
    name: 'booking-voucher',
    component: () => import('../views/booking/BookingVoucher.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/booking/:id/detail',
    name: 'booking-detail',
    component: () => import('../views/booking/BookingDetail.vue'),
    meta: { layout: appLayout }
  }
]
